export default "__VITE_ASSET__D9FZvGgQ__"